import { render, staticRenderFns } from "./RetailRozcestnik.vue?vue&type=template&id=049a8116&scoped=true"
import script from "./RetailRozcestnik.vue?vue&type=script&lang=js"
export * from "./RetailRozcestnik.vue?vue&type=script&lang=js"
import style0 from "./RetailRozcestnik.vue?vue&type=style&index=0&id=049a8116&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049a8116",
  null
  
)

export default component.exports